import { RecordDataSource } from "../../../records/grids";
import {
  ColumnDefinitionSetService,
  vsServiceName as ColumnDefinitionSetServiceName,
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
} from "../../../records/grids/columns/columnDefinitionSetService";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../records/views/recordGridView";
import { processInstancesName } from "../../../Process/config/objects";
import { vsObjectName as contractInstanceName } from "./contractInstance";

export const vsObjectName = "contractInstanceProcess";
export const vsProcessColumnSetName = `${vsObjectName}.process`;
export const vsContractColumnSetName = `${vsObjectName}.contract`;

contractProcessConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
];
export function contractProcessConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider,
) {
  columnDefinitionSetServiceProvider.addColumnDefinitionSet(
    vsProcessColumnSetName,
    [
      ColumnDefinitionSetServiceName,
      (columnDefinitionSetService: ColumnDefinitionSetService) =>
        columnDefinitionSetService.getColumnDefinitionSet(processInstancesName) ?? [],
    ],
  );

  columnDefinitionSetServiceProvider.addColumnDefinitionSet(
    vsContractColumnSetName,
    [
      ColumnDefinitionSetServiceName,
      (columnDefinitionSetService: ColumnDefinitionSetService) =>
        columnDefinitionSetService.getColumnDefinitionSet(
          contractInstanceName,
        ) ?? [],
    ],
  );

  columnDefinitionSetServiceProvider.addColumnDefinitionSet(vsObjectName, [
    ColumnDefinitionSetServiceName,
    (columnDefinitionSetService: ColumnDefinitionSetService) => [
      ...(columnDefinitionSetService.getColumnDefinitionSet(
        contractInstanceName,
      ) ?? []),
      ...(columnDefinitionSetService.getColumnDefinitionSet(processInstancesName) ?? []),
    ],
  ]);

  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    ServerUtilityName,
    GridSettingsServiceName,
    (
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService,
    ): GridConfiguration => {
      return {
        defaultSort: "SerialNumber,ContractNumber",
        gridDataSource: new RecordDataSource(
          serverUtility,
          "/api/contract/process",
        ),
        gridSettings: gridSettingsService.getGridSettings(Symbol(vsObjectName)),
        namePlural: "Contract Processes",
        nameSingular: "Contract Process",
        showAddButton: false,
        columnDefinitionSet: vsObjectName,
      };
    },
  ]);
}
